<script setup>
import PanelOrganic from '@/design/primitives/PanelOrganic.vue'
</script>

<template>
  <!-- Skeleton poster — mimics the 4:5 poster card shape while loading -->
  <PanelOrganic tone="glass" :padded="false" class="skeleton-poster" aria-hidden="true">
    <!-- Image area skeleton -->
    <div class="skeleton-poster__image u-shimmer" />

    <!-- Plate skeleton — bottom section -->
    <div class="skeleton-poster__plate">
      <!-- Title bar -->
      <div class="skeleton-poster__bar skeleton-poster__bar--title u-shimmer" />
      <!-- Description bar -->
      <div class="skeleton-poster__bar skeleton-poster__bar--desc u-shimmer" />
      <!-- Price row -->
      <div class="skeleton-poster__road">
        <div class="skeleton-poster__bar skeleton-poster__bar--price u-shimmer" />
        <div class="skeleton-poster__bar skeleton-poster__bar--btn u-shimmer" />
      </div>
    </div>
  </PanelOrganic>
</template>

<style scoped>
.skeleton-poster {
  overflow: hidden;
  display: flex;
  flex-direction: column;
  /* Match poster card: no padding from PanelOrganic */
  border-radius: var(--r-md);
}

/* Skeleton image — 4:5 aspect to match real poster */
.skeleton-poster__image {
  width: 100%;
  aspect-ratio: 4 / 5;
  border-radius: 0;
}

/* Plate — below the image block */
.skeleton-poster__plate {
  padding: var(--sp-3) var(--sp-3) var(--sp-4);
  display: flex;
  flex-direction: column;
  gap: var(--sp-2);
}

/* Generic bar */
.skeleton-poster__bar {
  border-radius: var(--r-xs);
  height: 14px;
}

.skeleton-poster__bar--title {
  width: 72%;
  height: 20px;
}

.skeleton-poster__bar--desc {
  width: 90%;
  height: 12px;
}

/* Price row */
.skeleton-poster__road {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--sp-2);
  margin-top: var(--sp-1);
}

.skeleton-poster__bar--price {
  width: 56px;
  height: 18px;
}

.skeleton-poster__bar--btn {
  width: 52px;
  height: 30px;
  border-radius: var(--r-sm);
}
</style>
